import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
// import * as crypto from 'crypto-js';
import { catchError } from 'rxjs/operators';
import { Appointment } from 'src/app/model/Security/Appointment';
import { HandleError } from '../http-error-handler.service';
import { GatePass } from 'src/app/model/Security/GatePass';
import { AppointmentForEmp } from 'src/app/model/Security/AppointmentForEmp';
import { GatePassList } from 'src/app/model/Security/GatePassList';
import { APIFactoryEndPoints } from 'src/app/common/apifactory-end-points';
import { FCMMessageRegistration } from 'src/app/model/Others/FCMMessageRegistration';
import { ProductionMaster } from 'src/app/model/Production/ProductionMaster';
import { ViewReport } from 'src/app/model/viewreport';
import { MakeToOrderProduction } from 'src/app/model/Production/MakeToOrderProduction';
import { PassThrough } from 'stream';
import { UserData } from 'src/app/model/Common/UserAccess/UserData';

@Injectable({
  providedIn: 'root'

})
export class CommonService {

  enableDisableFCMForUserWhenMonitoring(url: string, enableDisable: string) {
    return this.http.get(url + '/' + enableDisable);
  }
  getMessagesByUserId(userId: string, deviceType: string, noOfRec: number) {
    return this.http.get(this.apiFactory.getFirebasePushNotificationByUserId + '/' + userId + "/" + deviceType + "/" + noOfRec);
  }

  generateInvoiceObj: any = null;
  generateBosInvoiceObj: any = null;
  generateInvoiceObjForMto: any = null;
  rolReportToPurchaseOrder: any = null;
  bakeToUrl: string = null;
  generateTaxableReceiptObj: any = null;
  generateTaxableReceiptObjForMto: any = null;
  generateExemptedReceiptObj: any = null;
  generateExemptedReceiptObjForMto: any = null;
  generateReceiveReturnTaxableReceiptObj: any = null;
  generateReceiveReturnTaxableReceiptObjForMto: any = null;
  generateReceiveReturnExemptedReceiptObj: any = null;
  generateReceiveReturnExemptedReceiptObjForMto: any = null;

  getSubSubModuleAndRefNoByInternalName(apiUrl: string, subSubModule: string) {
    return this.http.get(apiUrl + "/" + subSubModule);
  }

  revokeSessionPermission(revokeSession: string) {
    return this.http.get(revokeSession);
  }
  isTokenValid(isTokenValid: string) {
    return this.http.get(isTokenValid);
  }
  // removeFCMRegistrationData(removeTokenByToken: string, token: string) {
  //   return this.http.get(removeTokenByToken + "/" + token);
  // }
  // removeFCMRegistrationDataByToken(url: string, token: string) {
  //   return this.http.get(url + "/" + token);
  // }
  updateTokenByDeviceID(url: string, token: string, deviceId: string) {
    return this.http.get(url + "/" + token + "/" + deviceId);
  }
  getInsuranceRenewalStatus(locId: any) {
    return this.http.get(this.apiFactory.getInsuanceRenewalStatusByLocationId + '/' + locId);
  }
  getAssetMaintenanceIssueStatus(locId: any) {
    return this.http.get(this.apiFactory.getAssetsMaintenanceIssueStatusByLocationId + '/' + locId);
  }
  getPerformanceUpdate(locId: any) {
    return this.http.get(this.apiFactory.getAssetsMaintenanceScheduleByLocationId + '/' + locId);
  }
  getMTOStatus(locId: number) {
    return this.http.get(this.apiFactory.getMTOReadyForProductionAndDispatchStatusByDateAndLocCode + '/' + locId);
  }
  getROLStatus(locId: any) {
    return this.http.get(this.apiFactory.getProductAvailableQtyAndROLbyLocationCode + '/' + locId);
  }
  getSaleStatus(locId: any) {
    return this.http.get(this.apiFactory.getdashboardSaleStatus + '/' + locId);
  }
  getMakeToOrderStatus(locId: any) {
    return this.http.get(this.apiFactory.getdashboardMakeToOrderStatus + '/' + locId);
  }
  getOrderStatus(locId: any) {
    return this.http.get(this.apiFactory.getdashboard + '/' + locId);
  }
  getActivityLog(locId: String, noOfRec: number) {
    return this.http.get(this.apiFactory.getTransLog + '/' + locId + "/" + noOfRec);
  }
  getSubSubMenuId(fullUrl: string) {
    return this.http.get(fullUrl);
  }
  getMenuId(fullUrl: string) {
    return this.http.get(fullUrl);
  }
  getSubMenuId(fullUrl: string) {
    return this.http.get(fullUrl);
  }
  sendNotification(url: string, locationCodes: number[], subject: string, message: string, messageType: string, refId: string, messageSource: number) {
    return this.http.get(url + "/" + locationCodes + "/" + subject + "/" + message + "/" + messageType + "/" + refId + "/" + messageSource);
  }

  exportMakeToOrderProductionData(getMaketToOrderDetailsByDateStatusAndLocation: string, viewReport: ViewReport) {
    throw new Error('Method not implemented.');
  }
  getMakeToOrderForProductionSearch(url: string, locId: number, orderNo: string) {
    return this.http.get(url + "/" + locId + "/" + orderNo);
  }
  deleteMakeToOrderProductionById(url: string, prodNo: string) {
    return this.http.patch(url + '/' + prodNo, null, { responseType: 'json' })
  }
  getMakeToOrderProductionDataForByDateRange(url: string, obj: ViewReport) {
    return this.http.post(
      url,
      obj

    );
  }
  getMakeToOrderProductionDetailsByProductionNo(url: string, prodNo: number) {
    return this.http.get(url + "/" + prodNo);
  }
  getMakeToOrderProductionNosByDateRange(url: string, obj: ViewReport) {
    return this.http.post(
      url,
      obj

    );
  }
  getMakeToOrderDetailsByDateStatusAndLocationCode(url: string, obj: ViewReport) {
    return this.http.post(
      url,
      obj

    );
  }
  cancelProduction(url: string, prodNo: string) {
    return this.http.patch(url + '/' + prodNo, null, { responseType: 'json' })
  }
  getProductionDetailsByProductionNo(url: string, prodNo: any) {
    return this.http.get(url + "/" + prodNo);
  }

  getEmployeeNameAndDepartmentList(url: string, employee: any) {
    return this.http.get(url + "/" + employee);
  }
  saveProductionData(url: string, productionData: ProductionMaster) {
    return this.http.post(
      url,
      productionData

    );
  }
  getEmployeeByLocAndDept(url: string, deptCode: any, locationId: number) {
    return this.http.get(url + "/" + deptCode + "/" + locationId);
  }
  getMessages(locId: number, deviceType: String, noOfRec: number): Observable<any> {
    return this.http.get(this.apiFactory.getFirebasePushNotification + '/' + locId + "/" + deviceType + "/" + noOfRec);
  }
  constructor(private http: HttpClient,
    private apiFactory: APIFactoryEndPoints) { }
  companyCode: number = 1;
  private handleError: HandleError;

  getCompanyList(): Observable<any> {
    return this.http.get(this.apiFactory.getAllCompany);
  }

  getDepartmentList(): Observable<any> {
    return this.http.get(this.apiFactory.viewDepartmentList);
  }
  // getEmployeeList(): Observable<any> {
  //   return this.http.get(this.apiFactory.employees);
  // }

  getStateList(): Observable<any> {
    return this.http.get(this.apiFactory.getstates);
  }

  fetchGateList(companyCode: number): Observable<any> {
    return this.http.get(this.apiFactory.getGateSetUp + "/" + companyCode);
  }

  getMaxAppointmentNo(): Observable<any> {
    return this.http.get(this.apiFactory.maxappointmentno);
  }

  getMaxGatePassNo(): Observable<any> {
    return this.http.get(this.apiFactory.maxgatepassno);
  }
  getUniqueID(url: string): Observable<any> {
    return this.http.get(url);
  }

  getCurrentDate() {
    var returnDate;
    var today = new Date();
    var dd = today.getDate();
    var mm = today.getMonth() + 1; //because January is 0! 
    var yyyy = today.getFullYear();
    returnDate = yyyy + "-";
    if (mm < 10) {
      returnDate += `0${mm}`;
    } else {
      returnDate += `${mm}`;
    }
    returnDate += "-";
    if (dd < 10) {
      returnDate += `0${dd}`;
    } else {
      returnDate += `${dd}`;
    }
    return returnDate;
  }

  changeDateFormat(dt: Date) {
    var returnDate;
    var today = new Date(dt);
    var dd = today.getDate();
    var mm = today.getMonth() + 1; //because January is 0! 
    var yyyy = today.getFullYear();
    returnDate = yyyy + "-";
    if (mm < 10) {
      returnDate += `0${mm}`;
    } else {
      returnDate += `${mm}`;
    }
    returnDate += "-";
    if (dd < 10) {
      returnDate += `0${dd}`;
    } else {
      returnDate += `${dd}`;
    }
    return returnDate;
  }


  getCurrentTime() {
    var today = new Date();
    var time = today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();
    return time;
  }

  getAppointmentList() {
    return this.http.get<Appointment[]>(this.apiFactory.getAllAppointments)
      .pipe(
        catchError(this.handleError('getAppointments()', []))
      );
  }

  getGatePassList() {
    return this.http.get<GatePass[]>(this.apiFactory.getAllGatePasses)
      .pipe(
        catchError(this.handleError('getGatePassList()', []))
      );
  }

  getGatePassVSAppointmentList() {
    return this.http.get<GatePassList[]>(this.apiFactory.getAllGatePassAppointmentList)
      .pipe(
        catchError(this.handleError('getGatePassVSAppointmentList()', []))
      );
  }



  getAppointmentListForEmpById(id: number): Observable<any> {
    return this.http.get<AppointmentForEmp>(this.apiFactory.listOfAppointmentForEmp + id)
      .pipe(
        catchError(this.handleError('getAppointmentListForEmpById()', []))
      );
  }

  getAppointmentListById(id: number): Observable<any> {
    return this.http.get(this.apiFactory.appointmentById + id)
      .pipe(
        catchError(this.handleError('getAppointmentListById()', []))
      );
  }
  getGatePassById(id: number): Observable<any> {
    return this.http.get(this.apiFactory.gatePassById + id)
      .pipe(
        catchError(this.handleError('getGatePassById()', []))
      );
  }

  deleteAppointments(id: number) {
    return this.http.delete<Appointment[]>(this.apiFactory.deleteAppointments + id)
      .pipe(
        catchError(this.handleError('deleteAppointments()', []))
      );
  }
  deleteGatePassAppointment(id: number) {
    return this.http.delete<GatePass[]>(this.apiFactory.deleteGatePass + id)
      .pipe(
        catchError(this.handleError('deleteGatePass()', []))
      );
  }
  saveFCMRegistrationData(url: string, formData: FCMMessageRegistration) {
    return this.http.post(
      url,
      formData

    );
  }
  getListOfProductsInProductionProcess(url: string, obj: ViewReport) {
    return this.http.post(
      url,
      obj

    );
  }
  getProductionNos(url: string, obj: ViewReport) {
    console.log(url)
    console.log(obj)
    return this.http.post(
      url,
      obj

    );
  }
  getMakeToOrderNosByDateRange(url: string, obj: ViewReport) {
    return this.http.post(
      url,
      obj

    );
  }
  getMakeToOrderDetailsByOrderNo(url: string, ordNo: string) {
    return this.http.get(url + "/" + ordNo);

  }
  getMakeToOrderForProductionInitialData(url: string, locId: any) {
    return this.http.get(url + "/" + locId);

  }
  saveMakeToOrderProductionData(url: string, productionData: MakeToOrderProduction) {
    return this.http.post(
      url,
      productionData

    );
  }
  updatePasswordOfUser(url: string, userData: UserData) {
    return this.http.post(
      url,
      userData

    );
  }


  encryptData(message) {
    // const password:String="myPass@393838#1";
    // const key = crypto.enc.Utf8.parse(password);
    // const iv = crypto.enc.Utf8.parse(password);
    // const encrypted = crypto.AES.encrypt(message, key, {
    //   keySize: 16,
    //   iv: iv,
    //   mode: crypto.mode.ECB,
    //   padding: crypto.pad.Pkcs7

    // });
    // return this.encryptData;
  }

  updateDashboardFilterType(url: string, type: string) {
    return this.http.get(url + '/' + type);
  }

  getDashboardTopDivData(locId: any) {
    return this.http.get(this.apiFactory.getdashboardTopDivData + '/' + locId);
  }

  getAllowedFinancialYear(url: string) {
    return this.http.get(url);
  }

  private fySubject = new BehaviorSubject<string | null>(null);

  setAllowedFinancialYear(fy: string) {
    this.fySubject.next(fy);
  }

  getAllowedFinancialYear$() {
    return this.fySubject.asObservable();
  }
}


